import {Component, ViewChild} from '@angular/core';
import {ReplaySubject} from 'rxjs';
import {NgForm} from '@angular/forms';
import {FormErrors} from '../../../../components/forms/validation/form-validator.class';
import {StepScreenModel} from '../../../shared/step/step-screen.component';
import {FileLocationFactory} from '../../../../components/files/service/file-location.class';
import {Model} from '../../../../domain/model/common/model.class';
import ProjectionInformation = Model.ProjectionInformation;
import {ActivatedRoute} from '@angular/router';
import {FileListService} from '../../../../components/files/service/file-list.service';
import {FileListComponentModel} from '../../../../components/files/file-list/file-list.component';
import {FileUploaderComponentModel} from '../../../../components/files/file-uploader/file-uploader.component';
import {AdminReportsService} from '../../../../domain/model/admin-reports/admin-reports.service';
import {AdminReports} from '../../../../domain/model/admin-reports/admin-reports.model';
import {VerificationService} from '../../../../components/verification/service/verification.service';

@Component({
    template: require('./admin-reports-screen.component.html')
})
export class AdminReportsScreenComponent {

    constructor(readonly modelService: AdminReportsService,
                readonly route: ActivatedRoute,
                readonly fileListService: FileListService,
                readonly fileLocationFactory: FileLocationFactory,
                readonly verificationService: VerificationService) {

        this.npdbFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.amaFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.backgroundFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.oigFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.samFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.licenseSanctionsFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
        this.medicareMedicaidSanctionFileUploaderModel.uploaded$.startWith(true).subscribe(_ => this._refreshFilesInfo());
    }

    // region Form
    readonly form$ = new ReplaySubject<NgForm>(1);

    @ViewChild(NgForm) set form(value: NgForm) {
        this.form$.next(value);
    }

    // endregion

    stepScreenModel = new StepScreenModel<AdminReports>({
        initialDataModel: new AdminReports(),
        specificValidationMessages: {},
        _loadDataFn: () => {
            this.verificationService.setUrl('adminReports');
            return this.modelService.getCurrentUserModel();
        },
        _submitDataFn: (model: AdminReports) => {
            return this.modelService.updateCurrentUserModel(model);
        }
    });

    npdbFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('npdbFile'))
    });

    npdbFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('npdbFiles'))
    });

    amaFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('amaFile'))
    });

    amaFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('amaFiles'))
    });

    backgroundFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('backgroundFile'))
    });

    backgroundFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('backgroundFiles'))
    });

    oigFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('oigFile'))
    });

    oigFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('oigFiles'))
    });

    samFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('samFile'))
    });

    samFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('samFiles'))
    });

    licenseSanctionsFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('licenseSanctionsFile'))
    });

    licenseSanctionsFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('licenseSanctionsFiles'))
    });

    medicareMedicaidSanctionFileListModel = new FileListComponentModel({
        files: [],
        fileBaseLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('medicareMedicaidSanctionFile'))
    });

    medicareMedicaidSanctionFileUploaderModel = new FileUploaderComponentModel({
        filesLocation: this.fileLocationFactory.create('adminReports', 'currentUser', new ProjectionInformation('medicareMedicaidSanctionFiles'))
    });

    get model(): AdminReports {
        return this.stepScreenModel.dataModel;
    }

    get formErrors(): FormErrors {
        return this.stepScreenModel.formErrors;
    }

    private _refreshFilesInfo() {
        this.fileListService.list(this.npdbFileUploaderModel.filesLocation).subscribe(files => this.npdbFileListModel.files = files);
        this.fileListService.list(this.amaFileUploaderModel.filesLocation).subscribe(files => this.amaFileListModel.files = files);
        this.fileListService.list(this.backgroundFileUploaderModel.filesLocation).subscribe(files => this.backgroundFileListModel.files = files);
        this.fileListService.list(this.oigFileUploaderModel.filesLocation).subscribe(files => this.oigFileListModel.files = files);
        this.fileListService.list(this.samFileUploaderModel.filesLocation).subscribe(files => this.samFileListModel.files = files);
        this.fileListService.list(this.licenseSanctionsFileUploaderModel.filesLocation).subscribe(files => this.licenseSanctionsFileListModel.files = files);
        this.fileListService.list(this.medicareMedicaidSanctionFileUploaderModel.filesLocation).subscribe(files => this.medicareMedicaidSanctionFileListModel.files = files);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/personal-details/steps/admin-reports/admin-reports-screen.component.ts